import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Switch from 'react-switch';

import { Day, Night } from '@poli-digital/react';
import { setDarkMode } from '../../../../../store/modules/theme';

function DarkMode() {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state?.theme?.isDarkMode);
  const isWhiteLabel = useSelector(
    (state) => state?.whitelabel?.config?.is_white_label
  );

  if (isWhiteLabel) {
    return null;
  }

  const handleToggle = () => {
    dispatch(setDarkMode(!isDarkMode));

    setTimeout(() => {
      document.dispatchEvent(new Event('themeChanged'));
    }, 150);
  };

  return (
    <label htmlFor="material-switch" className="darkModeTopNav">
      <span>
        <Day width="16" height="16" />
      </span>
      <Switch
        onChange={handleToggle}
        checked={isDarkMode}
        onColor={'#242b3d'}
        onHandleColor={'#6666DE'}
        handleDiameter={20}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={20}
        width={35}
        className="react-switch"
        id="material-switch"
      />
      <span>
        <Night width="16" height="16" />
      </span>
    </label>
  );
}

export default DarkMode;
